package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.Book4W500Rounded: ImageVector
    get() {
        if (_book4W500Rounded != null) {
            return _book4W500Rounded!!
        }
        _book4W500Rounded = Builder(name = "Book4W500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(240.0f, 888.13f)
                quadToRelative(-53.39f, 0.0f, -90.76f, -37.3f)
                quadToRelative(-37.37f, -37.3f, -37.37f, -90.59f)
                verticalLineToRelative(-559.28f)
                quadToRelative(0.0f, -53.79f, 37.65f, -91.44f)
                reflectiveQuadToRelative(91.44f, -37.65f)
                horizontalLineToRelative(347.56f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.61f)
                reflectiveQuadToRelative(26.61f, 64.39f)
                verticalLineToRelative(465.65f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(240.0f, 719.52f)
                quadToRelative(-16.8f, 0.0f, -28.16f, 11.5f)
                reflectiveQuadToRelative(-11.36f, 28.5f)
                quadToRelative(0.0f, 17.0f, 11.36f, 28.5f)
                reflectiveQuadToRelative(28.16f, 11.5f)
                horizontalLineToRelative(519.52f)
                verticalLineToRelative(-603.35f)
                quadToRelative(0.0f, -18.67f, 12.82f, -31.49f)
                quadToRelative(12.81f, -12.81f, 31.49f, -12.81f)
                quadToRelative(18.67f, 0.0f, 31.49f, 12.81f)
                quadToRelative(12.81f, 12.82f, 12.81f, 31.49f)
                verticalLineToRelative(600.96f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(240.0f, 888.13f)
                close()
                moveTo(369.09f, 632.11f)
                horizontalLineToRelative(221.82f)
                verticalLineToRelative(-471.63f)
                lineTo(369.09f, 160.48f)
                verticalLineToRelative(471.63f)
                close()
                moveTo(280.48f, 632.11f)
                verticalLineToRelative(-471.63f)
                horizontalLineToRelative(-39.52f)
                quadToRelative(-17.0f, 0.0f, -28.74f, 11.74f)
                quadToRelative(-11.74f, 11.74f, -11.74f, 28.74f)
                verticalLineToRelative(437.67f)
                quadToRelative(9.83f, -2.79f, 19.18f, -4.66f)
                quadToRelative(9.34f, -1.86f, 20.44f, -1.86f)
                horizontalLineToRelative(40.38f)
                close()
                moveTo(200.48f, 160.48f)
                verticalLineToRelative(478.15f)
                verticalLineToRelative(-478.15f)
                close()
            }
        }
        .build()
        return _book4W500Rounded!!
    }

private var _book4W500Rounded: ImageVector? = null
